var Selects = {
	/** 
	 * Initialize by:
	 * 1. Handling events
	 * 2. Replacing native selects for psuedo selects
	 * @params void
	 * @return void
	 *	
	 */
	init:function(){
		this.$el = $('form').eq(0);
		
		this.psuedoSelect = $.proxy(this.psuedoSelect,this);
		this.hidePsuedoSelect = $.proxy(this.hidePsuedoSelect,this);
		this.psuedoSelectOption = $.proxy(this.psuedoSelectOption,this);
		this.closeSelect = $.proxy(this.closeSelect,this);
		this.closeOverlay = $.proxy(this.closeOverlay,this);
		this.keyPress = $.proxy(this.keyPress,this);
		
		if(!Modernizr.touch) this.createPseudoSelects();
	},
	events:function(){
		this.$el
			.on('click','.psuedo-select + span',this.psuedoSelect)
			.on('click','.select li',this.psuedoSelectOption)
			.parent().on('click',this.closeOverlay)
			.on('keydown','input[type="text"]',{input:true},this.keyPress);
		
		// Ignore for mobile
		if (!this.mobile) $(document).on('keydown',this.keyPress);
	},
	
	/** 
	 * Allow a user to use the keyboard as input 
	 * on the selects
	 * @params object	event object
	 * @return void
	 *	
	 */
	keyPress:function(e){
		// As document and inputs both have handlers attached
		// To the keydown event, stop bubbling up if triggered
		// from input so the handler is not triggered twice
		if ($(e.currentTarget).is('input[type="text"]')){
			e.stopPropagation();
		} 
		var v = e.which;
		switch (true){
			// Tab
			case (v == 9):
				this.controlTab(e);
			break;
			// Esc
			case (v == 27):
				this.closeOverlay(e);
			break;
			// lower case and upper case letters
			case (v >= 65 && v <= 122):
				this.navigateToLetter(e);
			break;
		}
	},
	
	/** 
	 * If triggered from input el focus of select if
	 * select is the sibling element
	 * @params object	event object
	 * @return void
	 *	
	 */
	controlTab:function(e){
		var $activeSelect = this.$el.find('.input-container.select.active');
		if (e.data && e.data.input){
			var 
				el = e.currentTarget,
				$p = $(el).parents('.input-container') || false,
				$next = $p ? $p.eq(0).next() : $();
				if ($next.is('.select')){
					$next.find('.psuedo-select + span').trigger('click');
					$(el).blur();
					e.preventDefault();
					return;
				}
		} else if ( $activeSelect.length > 0){
			var $selectOne = $activeSelect.eq(0);
			this.forwardToNext($selectOne);
			var $next = $selectOne.next();
			this.closeOverlay(false,$selectOne.find('li:first-child')[0]);
			$next.find('input').focus();
			e.preventDefault();
		} else {
			e.preventDefault();
		}
	},
	
	forwardToNext:function($select){
		var 
			$next = $select.next(),
			$input = !$next.hasClass('select') ? $next.find('input').eq(0) : false;
		this.closeOverlay(false,$select.find('li:first-child')[0]);
		if ($input){
			$next.find('input').focus();	
		} else {
			setTimeout(function(){
				$next.find('.psuedo-select + span').trigger('click');
			}, 500);
		}
	},
	
	/** 
	 * If triggered from input el focus of select if
	 * select is the sibling element
	 * @params object	event object
	 * @return void
	 *	
	 */
	navigateToLetter:function(e){
		var $p = $('.input-container.select');
		if ($p.hasClass('active')){
			var letter = String.fromCharCode(e.which) || 'a';
			this.psuedoSelectGoToActive($p.filter('.active'),letter);
		}
	},
	
	/** 
	 * Create Psuedo select elements
	 * @params object	event object
	 * @return void
	 *	
	 */
	createPseudoSelects:function(e){
		var $select = this.$el.find('select');
		var selects = [], i = 1;
		$select.each(function(){
			var select = {
				name: $(this).attr('name'),
				parent: $(this).parents('.input-container'),
				required: $(this).attr('aria-required') ? true : false,
				options: []
			};
			$options = $(this).find('option');
			$options.each(function(){
				select.options.push({
					html:this.innerHTML,
					value:$(this).val()
				});
			})
			selects.push(select);
			$(this).remove();		
		})
		selects.forEach(function(index){
			var $ul = $('<ul></ul>').addClass(index.name);
			var $input = $('<input type="text">');
			var opts = {
				disabled:true,
				name:index.name,
				'aria-required': index.required
			};
			opts["class"] = "psuedo-select";
			$input.attr(opts);
			index.options.forEach(function(option){
				var $option = $('<li></li>').html(option.html).attr('data-value',option.value);
				$ul.append($option);
			});
			$span = $('<span></span>').attr('data-index',i);
			index.parent.append($input).append($span);
			index.parent.append($ul);
			i++;
		});
		this.events();
	},
	
	/** 
	 * Control click trigger for select element
	 * @params object	event object
	 * @return void
	 *	
	 */
	psuedoSelect:function(e){
		var $el = $(e.currentTarget);
		var $parent = $el.parents('.input-container').addClass('active');
		this.$el.find('.input-container').not($parent).removeClass('active');
		this.oldSelect = this.activeSelect || false;
		this.activeSelect = $el.data('index');
		if (this.oldSelect == this.activeSelect) this.psuedoSelectGoToActive($parent);
	},
	
	/** 
	 * Scroll to active option if previously selected
	 * @params object jQuery object of parent element
	 * @return void
	 *	
	 */
	psuedoSelectGoToActive:function($parent,letter){
		var 
			val = $parent.find('input').attr('data-value'),
			$ul = $parent.find('ul'),
			$li = $ul.find('li'),
			el;
		
		if(letter){
			$li.each(function(){
				var character = this.innerHTML.substr(0,1);
				if (letter == character){
					el = this;
					return false;
				}
			});
		} else if (val){
			el = $('li[data-value="'+val+'"]')[0];
		} else {
			// If a value doesn't exist for this select, return
			return;
		}
		
		var index = $li.index(el);
		if (index) {
			var offset = (index - 1)*($(el).height() + 1);
			$ul.stop().animate({scrollTop: offset});
		}
	},
	
	/** 
	 * Hide psuedo element overlay
	 * @params object	event object
	 * @return void
	 *	
	 */
	psuedoSelectOption:function(e){
		var $el = $(e.currentTarget);
		var $parent = $el.parents('.input-container');
		var $input = $parent.find('input').eq(0).val($el.html()).attr('data-value',$el.data('value'));
		this.closeSelect(e);
	},
	
	/** 
	 * Generic form clicks trigger this function
	 * use to hide either the select overlay 
	 * or the legal form overlay
	 * @params object	event object
	 * @return void
	 *	
	 */
	closeOverlay:function(e,el){
		if (this.$el.find('.select.active').length > 0) this.closeSelect(e,el);
	},
	
	/** 
	 * Hide psuedo element overlay
	 * @params object	event object
	 * @return void
	 *	
	 */
	closeSelect:function(e,el){
		var 
			$target,
			target = el || e.target || e.toElement || false;
			
		if (target){
			$target = $(target);
		} else {
			return false;
		}
		
		// Check to see if the event happened on a select, return if so
		if ( $target.parents('.input-container.select').length > 0){
			if (!$target.is('li')) return false;
		}
		
		// Hide any active selects
		var $el = this.$el.find('.input-container.select');
		if ( !$el.hasClass('active') ) return;
		$el.find('ul').fadeOut(300,function(){
			$(this).attr({style:''});
			$el.removeClass('active');
		})
		
		$('body').trigger('Form__selectClosed');
	}
};

module.exports = Selects;